module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Bucket-72306251e3d72316d895235af79f51a8.svg";